// 9fbef606107a605d69c0edbcd8029e5d
import { getGiftWrapOptions } from '@tcp/core/src/components/features/CnC/Checkout/organisms/ShippingPage/molecules/GiftServices/container/GiftServices.selector';
import { resetEddData } from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.actions';
import { connect } from 'react-redux';
import {
  getFormValues,
  initialize,
  isDirty,
  isInvalid,
  isPristine,
  submit,
  change,
} from 'redux-form';
import { getOrderEddDates } from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.selectors';
import CHECKOUT_ACTIONS, {
  setPhoneCountry,
  setSMSUpdatesActn,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import {
  getCartOrderList,
  getOrderShipments,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import {
  resetZipForTaxEstimation,
  plccShippingAddressUpdate,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import { getECOMStatus } from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import {
  getHolidayMessage,
  getGiftServiceVisible,
  getIsAppPaymentRedesignEnabled,
  getIsRedesignedPaymentStepKillSwitch,
  getIsMakeDefaultUxUpdateKillSwitch,
  getIsDynamicFreeShippingEnabled,
  getOrderTrackingEnhancementEnabled,
  getIsInternationalPhoneNumber,
  getGiftServiceOnBagSection,
  getIsAddressVerificationBadgeEnabled,
  getSMSUpdatesAPIOptimization,
  getSMSUpdatesSingleOptInEnabled,
  getIsShippingMethodOnShippingEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { verifyAddress } from '@tcp/core/src/components/common/organisms/AddressVerification/container/AddressVerification.actions';

import CheckoutSelector, {
  isGuest,
  getLoginV2FlowEnabled,
  getSmsPhoneCountryCode,
} from '../../../Checkout/container/Checkout.selector';
import GiftCardsSelectors from '../../../Checkout/organisms/GiftCardsSection/container/GiftCards.selectors';
import Shipping from '../../molecules/Shipping';
import BAGPAGE_SELECTORS, {
  getFreeShippingThresholdValue,
  getOrderType,
} from '../../../BagPage/container/BagPage.selectors';
import {
  activateSpcSection,
  recalibrateSectionStates,
  saveAddressFromMelissa,
  saveAndContinueShipping,
  updateSectionState,
  setShowAddressVerification,
  setSFSErrors,
  addSFSItemsToSFL,
  clickedOutsideShipping,
} from '../SinglePageCheckout.actions';
import { SPC_BUTTON, SPC_SECTION } from '../SinglePageCheckout.constants';
import {
  getSinglePageCheckoutSectionState,
  showAddressVerification,
  getSfsError,
  clickedOutsideShippingFlag,
  getShouldShowShipmentMethodsCollapsed,
  checkIsShippingDetailsSaved,
} from '../SinglePageCheckout.selector';
import { SHIPPING_FORM_NAME } from './Shipping.constants';
import {
  fetchShipmentMethods,
  updateShipmentMethodSelection,
} from '../../../Checkout/container/Checkout.action';
import getGiftWrapValues from './Shipping.selector';
import {
  getProductTotal,
  getShippingTotal,
} from '../../../common/organism/OrderLedger/container/orderLedger.selector';
import { getContactFormValues, getShippingFormValuesFromSS } from './Shipping.utils';
import {
  getUserEmail,
  getUserLoggedInState,
  getUserPhoneNumber,
} from '../../../../account/User/container/User.selectors';

const formName = SHIPPING_FORM_NAME;

const mapStateToProps = (state) => {
  const shippingFormInput = getFormValues(formName)(state);
  const pristine = isPristine(formName)(state);
  const dirty = isDirty(formName)(state);
  const invalid = isInvalid(formName)(state);
  const giftServicesInput = getFormValues('GiftServices')(state);
  const savedShippingValues = CheckoutSelector.getShippingDestinationValues(state);
  const savedAddress = CheckoutSelector.getShippingAddress(state);
  const selectedShipmentId = savedShippingValues?.method?.shippingMethodId;
  const saveBtnLoadingStatus = getSinglePageCheckoutSectionState()(state, SPC_BUTTON.SAVE_SHIPPING);
  const defaultShipmentId = CheckoutSelector.getDefaultShipmentID(state);
  const isLoggedIn = getUserLoggedInState(state);
  const isEcomOrder = getECOMStatus(state);

  const loggedInUser = {
    emailAddress: getUserEmail(state),
    phoneNumber: getUserPhoneNumber(state),
  };
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.SHIPPING);

  const contactFormValuesFromSS = getShippingFormValuesFromSS(contactData);
  const shippingContactInfo = CheckoutSelector.getShippingContactInfo(state);
  const isShippingMethodsOnShippingEnabled = getIsShippingMethodOnShippingEnabled(state);

  return {
    formName,
    section: getSinglePageCheckoutSectionState()(state, SPC_SECTION.SHIPPING),
    shippingFormInput,
    pristine,
    dirty,
    invalid,
    giftServicesInput,
    savedAddress,
    savedGiftService: getGiftWrapValues(state),
    selectedShipmentId: selectedShipmentId || defaultShipmentId,
    saveBtnLoadingStatus,
    nonCacheBagLoading: BAGPAGE_SELECTORS.isNonCacheBagLoading(state),
    isGuestUser: isGuest(state),
    orderEddDates: getOrderEddDates(state),
    giftWrapOptions: getGiftWrapOptions(state),
    shipmentMethods: CheckoutSelector.getShipmentMethods(state),
    shippingMethodSelected: CheckoutSelector.getSavedShippingMethod(state),
    showAddressVerification: showAddressVerification(state),
    checkoutServerError: CheckoutSelector.getCheckoutServerError(state),
    venmoPayInProgress: CheckoutSelector.isVenmoPaymentInProgress(state),
    sfsError: getSfsError(state),
    cartOrderItems: getCartOrderList(state),
    isLoadingShippingMethods: GiftCardsSelectors.getIsLoading(state),
    isUpdatingShipmentMethods: GiftCardsSelectors.getIsUpdatingShipmentMethods(state),
    clickedOutsideShippingFlag: clickedOutsideShippingFlag(state),
    isLoginV2FlowEnabled: getLoginV2FlowEnabled(state),
    holidayMessageEnabled: getHolidayMessage(state),
    isGiftServiceVisible: getGiftServiceVisible(state),
    isGcEnabledOnBagSection: getGiftServiceOnBagSection(state),
    shouldShowShipmentMethodsCollapsed: getShouldShowShipmentMethodsCollapsed(state),
    shippingReduxForm: CheckoutSelector.getShippingReduxFormValues(state),
    isAppPaymentRedesignEnabled: getIsAppPaymentRedesignEnabled(state),
    isWebPaymentRedesignEnabled: getIsRedesignedPaymentStepKillSwitch(state),
    isMakeDefaultUxUpdateEnabled: getIsMakeDefaultUxUpdateKillSwitch(state),
    freeShippingThershold: getFreeShippingThresholdValue(state),
    shippingTotal: getShippingTotal(state),
    isDynamicFreeShippingEnabled: getIsDynamicFreeShippingEnabled(state),
    shipments: getOrderShipments(state),
    orderType: getOrderType(state),
    productTotal: getProductTotal(state),
    smsSignUpLabels: CheckoutSelector.getSmsSignUpLabels(state),
    initShippingPage: CheckoutSelector.getShippingInitialSectionValues(state),
    shippingContactInfo: CheckoutSelector.getShippingContactInfo(state),
    contactFormData: getContactFormValues({
      isLoggedIn,
      loggedInUser,
      contactFormValuesFromSS,
      shippingContactInfo,
    }),
    orderTrackingEnhancementEnabled: getOrderTrackingEnhancementEnabled(state),
    isShippingSectionSaved: checkIsShippingDetailsSaved(state),
    isSmsSignedUp: CheckoutSelector.getIsSMSSignUp(state),
    isInternationalPhoneNumberEnabled: getIsInternationalPhoneNumber(state),
    isAddressVerificationBadgeEnabled: getIsAddressVerificationBadgeEnabled(state),
    smsPhoneCountryCode: getSmsPhoneCountryCode(state),
    smsUpdatesAPIOptimization: getSMSUpdatesAPIOptimization(state),
    isSMSUpdatesSingleOptInEnabled: getSMSUpdatesSingleOptInEnabled(state),
    isShippingMethodsOnShippingEnabled,
    isShowShipmentMethodInCollapsed:
      isShippingMethodsOnShippingEnabled && defaultShipmentId && isLoggedIn && isEcomOrder,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSaveAndContinueShipping: (payload) => dispatch(saveAndContinueShipping(payload)),
  fillFormOnEdit: (payload) => dispatch(initialize(payload)),
  updateSectionState: (payload) =>
    dispatch(updateSectionState({ id: SPC_SECTION.SHIPPING, section: payload })),
  saveAddressFromMelissa: (payload) => dispatch(saveAddressFromMelissa(payload)),
  triggerFormSubmit: () => dispatch(submit(formName)),
  activateSpcSection: () => dispatch(activateSpcSection({ id: SPC_SECTION.SHIPPING })),
  recalibrateSectionStates: () => dispatch(recalibrateSectionStates()),
  loadShipmentMethods: (shippingFormName) => {
    dispatch(fetchShipmentMethods(shippingFormName));
  },
  updateShipmentMethods: (payload) => {
    dispatch(updateShipmentMethodSelection(payload));
  },
  toggleShowAddressVerification: (payload) => {
    dispatch(setShowAddressVerification(payload));
  },
  clearCheckoutServerError: (payload) => dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(payload)),
  dispatchFormFieldChange: (key, value) => dispatch(change(formName, key, value)),
  dispatchGiftFormFieldChange: (key, value) => dispatch(change('GiftServices', key, value)),
  setSFSErrors: (payload) => {
    dispatch(setSFSErrors(payload));
  },
  resetZipCode: (payload) => {
    dispatch(resetZipForTaxEstimation(payload));
  },
  addSFSItemsToSFL: (payload, navigation) => {
    dispatch(addSFSItemsToSFL(payload, navigation));
  },
  resetShippingEddData: () => {
    dispatch(resetEddData());
  },
  plccShippingAddressUpdateActn: (payload) => {
    dispatch(plccShippingAddressUpdate(payload));
  },
  clickedOutsideShipping: (payload) => dispatch(clickedOutsideShipping(payload)),
  verifyAddressAction: (payload) => {
    dispatch(verifyAddress(payload));
  },
  setPhoneCountryAction: (payload) => dispatch(setPhoneCountry(payload)),
  setSMSUpdatesAction: (payload) => dispatch(setSMSUpdatesActn(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Shipping);
